<template>
  
  <div style="margin-left: 20">
    <div class="container">
        <div class="row">
        <!-- {{store.state.userRole}}
        {{store.state.group}} -->
                <table width="100%">
                <tr>
                    <td width="33%">
                       <b>Analyst Feedback Tracker</b>
                    </td>
                
                <td width="33%" align="center">
                        <img src="./../resource/mstar_dbrs_logo.png" width="250" height="70">
                    </td>
                     <td width="33%">
                        <button class="logout" @click="logout">
                            Sign Out 
                        </button>
                        <span class="logoutUser"><strong>{{store.state.user}}</strong>  &nbsp;</span> 
                    </td>
                </tr>
                 <tr bgcolor="#f1f1f1" height="40px;">
                 <td colspan='3'>
                    <table >
                        <tr align='center'>
                            <td  style ="padding-right :10px;padding-left :10px" v-if="userRole ==='restricted admin internal' || userRole ==='admin' || userRole ==='user'" :class="currenthiglightedMenu==='/' || currenthiglightedMenu==='/feed-back'? selectedtheme:notselectedtheme">
                                <a v-if="group =='CRS'" href="/CRS/" :class="currenthiglightedMenu==='/CRS/' || currenthiglightedMenu==='/CRS/feed-back'? selectedtheme:notselectedtheme">Feedback form</a>
                                <a v-else href="/" :class="currenthiglightedMenu==='/' || currenthiglightedMenu==='/feed-back'? selectedtheme:notselectedtheme">Feedback form</a>
                            </td>
                            
                            <td style ="padding-right :10px;padding-left :10px" v-if="userRole ==='restricted admin external' || userRole ==='restricted admin internal' || userRole ==='admin'" :class="currenthiglightedMenu==='/report'? selectedtheme:notselectedtheme">
                              <a v-if="group =='CRS'" :class="currenthiglightedMenu==='/CRS/report'? selectedtheme:notselectedtheme" href="/CRS/report">Reports</a>
                              <a v-else :class="currenthiglightedMenu==='/report'? selectedtheme:notselectedtheme" href="/report">Reports</a>
                            </td>
                             
                       
                           <td style ="padding-right :10px;padding-left :10px" v-if="userRole ==='restricted admin external' || userRole ==='restricted admin internal' || userRole ==='admin'" :class="notselectedtheme">
                                <a v-if="group =='CRS'" :class="currenthiglightedMenu==='/CRS/dashboard'? selectedtheme:notselectedtheme" href="/CRS/dashboard">Dashboard</a>
                                <a v-else :class="currenthiglightedMenu==='/dashboard'? selectedtheme:notselectedtheme" href="/dashboard">Dashboard</a>
                            </td>
                
                            <td style ="padding-right :10px;padding-left :10px" v-if="userRole ==='admin'" :class="currenthiglightedMenu==='/RegisterUser'? selectedtheme:notselectedtheme">
                              <a v-if="group =='CRS'" :class="currenthiglightedMenu==='/CRS/RegisterUser'? selectedtheme:notselectedtheme" href="/CRS/RegisterUser">Register User</a> 
                              <a v-else :class="currenthiglightedMenu==='/RegisterUser'? selectedtheme:notselectedtheme" href="/RegisterUser">Register User</a>
                            </td>
                            
                            <td style ="padding-right :10px;padding-left :10px"  :class="currenthiglightedMenu==='/feedbackStatus'? selectedtheme:notselectedtheme">
                              <a v-if="group =='CRS'" :class="currenthiglightedMenu==='/CRS/feedbackStatus'? selectedtheme:notselectedtheme" href="/CRS/feedbackStatus">Feedback Status</a> 
                              <a v-else :class="currenthiglightedMenu==='/feedbackStatus'? selectedtheme:notselectedtheme" href="/feedbackStatus">Feedback Status</a>
                            </td>
                        </tr>
                    </table>
                    </td>
                </tr>
                 <tr>
                        <td>
                        &nbsp;&nbsp;
                        </td>
                    </tr>
                </table>
        </div>
    </div>
  </div>
  </template>

<script>
import { logoutUim } from '@/apis/userauthentication';
import store from '@/store'
export default {
                    name: 'Menu',
                    setup () {
                                return {
                                store
                                }
                                },
                                computed: {
                                group: function() {return store.methods.getGroup()},
                                userRole: function() {return store.methods.getuserRole()},
                                user: function() {return store.methods.getUser()}
                                },
                            data () {
                            return {
                                        
                                        currenthiglightedMenu:'',
                                        selectedtheme: 'selectedMenu',
                                        notselectedtheme : 'notselectedMenu',
                                    }
                                },
                                mounted :function() {
                                       
                                        this.highlightMenu();
                                },
                                
                                    methods:{
                                        logout() {
                                        const successUrl = new URL(window.location.href);
                                            logoutUim(successUrl);
                                        },
                                        highlightMenu(){
                                                    let currentUrl = new URL(window.location.href);
                                                    this.currenthiglightedMenu = currentUrl.pathname; 
                                        }
                                        
                                    }
                }
</script>

<style>

.notselectedMenu {
    background: #f1f1f1;
    font-weight: normal;
    color: #585858;
}

.selectedMenu {
    background: #c7c7c7;
    font-weight: bold;
    color: #585858;
}

.logoutUser {
float: right;
}
</style>
